import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const CompletedIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4ZM12 6C8.69 6 6 8.69 6 12C6 15.31 8.69 18 12 18C15.31 18 18 15.31 18 12C18 8.69 15.31 6 12 6Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

CompletedIcon.propTypes = {
  sx: PropTypes.object,
};

export default CompletedIcon;
